// Env.staging.ts
const VEHICLE_API_URL = 'https://parking-api.staging.parkstory.actihosting.de/api/';
export { VEHICLE_API_URL };

const RESERVATION_API_URL = 'https://reservation-api.staging.parkstory.actihosting.de/api/';
export { RESERVATION_API_URL };

const APP_INSIGHTS_CONNECTION_STRING = 'InstrumentationKey=cb173a6a-28f4-4853-a177-d07f67ab73cf;IngestionEndpoint=https://germanywestcentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://germanywestcentral.livediagnostics.monitor.azure.com/;ApplicationId=d9a3588d-772b-4584-a1a9-a2525ea86118';
export { APP_INSIGHTS_CONNECTION_STRING };